import productService from "@/modules/produit/services/productService";

export default {
  install(Vue) {
    Vue.prototype.$ImageAlt = event => {
      productService
        .getImage(event.target.src)
        .then(res => {

          
          // console.error(res.data);
          // if (res.data != "") {
          event.target.src = res.data;
          // } else {
          //   event.target.src = `${process.env.VUE_APP_API_URL}/static/vignettes/non-disponible.jpg`;
          // }
        })
        .catch(err => {
          console.error(err);
        });
    };
  }
};
